import { lazy } from 'react';

const CharityVettingConsumptionTypeEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingConsumptionType" */ '../components/steps/consumption-type-step/ConsumptionType'
    ),
);

export default CharityVettingConsumptionTypeEntry;
